module.exports = __webpack_public_path__ + "static/example-tag-list-8731b48dfd11cdbbb1bb7ef24c54d9ed.png";